import type { Extension, Operation } from '../../model/extension/types';
import type { ExtensionLoadGql } from '../../model/graphql';

export const transformExtensionLoad = (response: ExtensionLoadGql): Extension => {
	const operations: Operation[] = response.extension
		? response.extension.operations.map((op) => ({
				icon: { url: op.icon && op.icon.url },
				name: op.name,
				url: op.url,
				tooltip: op.tooltip,
				styleClass: op.styleClass,
			}))
		: [];

	return {
		operations,
	};
};
